import React from 'react';
import { Reveal } from './ui/Reveal';
import { PRODUCT_IMAGE, SYSTEM_STATS, YOGA_STYLES, SYSTEM_TOPICS, LEVELS } from '../data/content';
export function SystemIntro() {
  return <section className="w-full bg-cream py-20 sm:py-24" data-id="element-216" data-mp="238dfwnfyigvd">
      <div className="mx-auto max-w-6xl px-5" data-id="element-217" data-mp="23ayjbgvwl4v8">
        <div className="flex flex-col items-center gap-10 text-center" data-id="element-218" data-mp="288860orwr2fd">
          <Reveal className="mx-auto max-w-3xl" data-id="element-219" data-mp="1bhph3i1r9nkv">
            <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-220" data-mp="1bj0so41fzzmj">
              RecursosFitness™ presenta
            </p>
            <h2 className="mt-3 font-serif text-4xl font-semibold text-ink sm:text-5xl" data-id="element-221" data-mp="1fl45ox3rfc9x">
              Yoga 360
            </h2>
            <p className="mx-auto mt-4 max-w-md text-lg leading-relaxed text-muted" data-id="element-222" data-mp="1pi09wqmmlc8o">
              Sistema completo para instructoras de Yoga. Todo tu año organizado,
              estructurado y listo para usar.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4" data-id="element-223" data-mp="30v2nrdxcbnp5">
              {SYSTEM_STATS.map(stat => <div key={stat.value} className="rounded-xl border border-sand bg-sand/60 p-4" data-id="element-224" data-mp="15i3zpzx2b0v9">
                  <div className="font-serif text-xl font-semibold text-sage-deep" data-id="element-225" data-mp="11hjzgnh6zh4w">
                    {stat.value}
                  </div>
                  <div className="mt-1 text-xs leading-snug text-muted" data-id="element-226" data-mp="riusvquqxj3y">{stat.label}</div>
                </div>)}
            </div>

            <div className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-227" data-mp="mkkyhiguimje">
              {YOGA_STYLES.map(s => <span key={s} className="rounded-full bg-sage/12 px-3 py-1 text-sm font-medium text-sage-deep" data-id="element-228" data-mp="hri45848v925">
                  {s}
                </span>)}
            </div>
            <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-229" data-mp="3t0idfxwg6mv">
              {SYSTEM_TOPICS.map(s => <span key={s} className="rounded-full border border-sand px-3 py-1 text-sm text-ink/70" data-id="element-230" data-mp="3uz31v6vuddwo">
                  {s}
                </span>)}
            </div>
          </Reveal>

          <Reveal delay={0.1} className="w-full max-w-2xl" data-id="element-231" data-mp="3q8z8jtpcihvp">
            <div className="overflow-hidden rounded-[2rem] shadow-2xl shadow-sage-deep/15" data-id="element-232" data-mp="3ccc99k9x7fmm">
              <img src={PRODUCT_IMAGE} alt="Los 7 tomos y bonos de Yoga 360 en formato digital" className="w-full object-cover" data-id="element-233" data-mp="3gdxi8ujc39rj" />
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-14" data-id="element-234" data-mp="cy9ww5uhe2xb">
          <div className="rounded-2xl border border-sand bg-sand/50 p-6 sm:p-8" data-id="element-235" data-mp="3vaycp5swtitp">
            <p className="mb-4 text-center text-sm font-semibold uppercase tracking-widest text-muted" data-id="element-236" data-mp="364978b9i7nx">
              Pensado para todos los formatos y niveles
            </p>
            <div className="flex flex-wrap justify-center gap-2.5" data-id="element-237" data-mp="qu3x80h6vjyt">
              {LEVELS.map(l => <span key={l} className="rounded-lg bg-white px-3.5 py-1.5 text-sm font-medium text-ink shadow-sm" data-id="element-238" data-mp="vohte53odv4j">
                  {l}
                </span>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}